<script setup lang="ts">
import CatalogIndex from '@/views/catalog/CatalogIndex.vue'

/**
 * Catálogo de productos.
 *
 * Solo búsqueda: la tabla `products` no tiene columna `type`, así que un filtro por
 * categoría no podría filtrar nada. El cuerpo vive en `CatalogIndex.vue`, que es el
 * mismo para las dos pantallas del catálogo.
 */
</script>

<template>
  <CatalogIndex kind="products" />
</template>
